/**
 * `.layer-faq` accordion + `.layer-request` btn-more reveal.
 * Port 1:1 din legacy common.js lines 2466-2489.
 */

import { $ } from '../core/selector.js';

export function initFaq(): void {
    const faq = $('.layer-faq') as Element | null;
    faq?.on('click', 'a.question', function (this: Element) {
        this.classList.toggle('opened');
        (this.nextElementSibling as Element | null)?.slideToggle(function (this: Element, visible: boolean) {
            (this.previousElementSibling as Element | null)?.classList.toggle('fill', visible);
        });
    });

    // FAQ radio buttons — stop propagation pe input.
    const faqRadio = $('.layer-faq.radio-buttons') as Element | null;
    faqRadio?.on('click', 'input', function (e: Event) {
        e.stopPropagation();
    });
}

export function initLayerRequest(): void {
    const layer = $('.layer-request') as Element | null;
    layer?.on('click', 'a.btn-more', function (this: HTMLElement) {
        ($('.layer-request .more-details') as HTMLElement | null)?.slideDown();
        this.style.display = 'none';
    });
}
